import { AudiencesScreen, CampaignIntelligenceScreen } from "components/animations/product-screens";
import React, { useState } from "react";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import { type ProgressTabProps, ProgressTabs } from "ui/tabs";
import { TextTitle } from "ui/text";
import mobileProductScreen1 from "../../../../public/assets/product-screens/audience-builder-mobile.png";
import productScreen2 from "../../../../public/assets/product-screens/ai-decisioning-messages.png";
import mobileProductScreen2 from "../../../../public/assets/product-screens/ai-decisioning-messages-mobile.png";
import mobileProductScreen3 from "../../../../public/assets/product-screens/insights-mobile.png";

export function RetailProductSlideshow() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabs: ProgressTabProps[] = [
    {
      id: "retail-tab-1",
      title: "Build and test any audience",
      description: "Explore, manage, and test paid and lifecycle audiences with a no-code suite of tools.",
      cta: {
        variant: "primary",
        href: "/platform/customer-studio",
        label: "Learn more about Customer Studio",
      },
      media: (
        <ProductShowcase
          isPriority
          variant="desert"
          productScreen={<AudiencesScreen isActive={activeTabIndex === 0} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={mobileProductScreen1}
              alt="Hightouch Audience builder named 'USA Active Customers' with filters selecting users with their country equal to 'USA' and had viewed a product greater than $50 within 7 days."
            />
          }
        />
      ),
    },
    {
      id: "retail-tab-2",
      title: "Automate customer journeys",
      description: "Send the right message to every customer every time with AI Decisioning.",
      cta: {
        variant: "primary",
        href: "/platform/ai-decisioning",
        label: "Learn more about AI Decisioning",
      },
      media: (
        <ProductShowcase
          isPriority
          variant="mustard"
          productScreen={
            <ProductShowcaseImage
              src={productScreen2}
              alt="An illustrated of UI displaying selectable channels like emails, SMS, and push notifications with corresponding messages linked to different campaigns."
            />
          }
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={mobileProductScreen2}
              alt="Hightouch Journey named 'Revival campaign', running a live campaign that sends an email notification to audiences with churn risk."
            />
          }
        />
      ),
    },
    {
      id: "retail-tab-3",
      title: "Measure performance",
      description: "Measure incremental lift and attribution with Campaign Intelligence.",
      cta: {
        variant: "primary",
        href: "/platform/campaign-intelligence",
        label: "Learn more about Campaign Intelligence",
      },
      media: (
        <ProductShowcase
          isPriority
          variant="poppy"
          productScreen={<CampaignIntelligenceScreen isActive={activeTabIndex === 2} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={mobileProductScreen3}
              alt="Hightouch Campaign Intelligence displaying a graph regarding how much revenue a user earned from campaigns within the last year."
            />
          }
        />
      ),
    },
  ];

  return (
    <>
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title="Power personalization and loyalty with a data platform built for marketers"
        maxW="2xl"
        mb={{ base: "bigger", md: "huge" }}
      />

      <ProgressTabs
        prerenderMedia={false}
        theme="dark"
        tabs={tabs}
        onChangeTab={(index) => {
          setActiveTabIndex(index);
        }}
      />
    </>
  );
}
